import React, { useState } from "react";
import StyledTitle from "../StyledTitle";

const ServiceHighlightsSection = ({ title, subtitle, text, highlights = [], defaultImage }) => {
	const [selectedImage, setSelectedImage] = useState(defaultImage.props.src);

	const handleImageChange = (image) => {
		setSelectedImage(image);
	};

	return (
		<div className="flex flex-col gap-8 lg:gap-16">
			<div className="flex flex-col w-full items-start">
				<StyledTitle
					titleColor="text-ipxon-white"
					titleSize="text-3xl md:text-4xl"
					titleText={title}
					subtitleText={subtitle}
					centered={true}
					labelText={text}
				/>
			</div>

			<div className="flex flex-col xl:flex-row w-full justify-between gap-8">
				<ul className="2xl:w-1/3 flex flex-col justify-between gap-8">
					{highlights.map((highlight, idx) => (
						<li
							key={idx}
							className="flex flex-col gap-4 group cursor-pointer"
							onClick={() => handleImageChange(highlight.image.props.src)}
						>
							<div className="flex items-center gap-2">
								{highlight.icon ? (
									<span className="group-hover:rotate-90 transition-all duration-300">
										{highlight.icon}
									</span>
								) : null}
								<h4 className="uppercase font-bold text-base transition-all duration-300">
									{highlight.title}
								</h4>
							</div>
							<p className="text-base w-full text-ipxon-medium-dark-gray">{highlight.text}</p>
						</li>
					))}
				</ul>
				<div className="items-center transition-all duration-500 text-black font-bold justify-center flex rounded-lg">
					<img
						className="rounded-[10px] w-full highlight-image-custom-size 2xl:max-w-[1000px] 2xl:max-h-[500px]"
						src={selectedImage}
						alt="Selected service"
					/>
				</div>
			</div>

			{/* <div className="flex self-start md:self-end">
				<div className="min-w-[147px]">
					<PrimaryOutlineButton onClick={onClickHandler}>
						SETUP
					</PrimaryOutlineButton>
				</div>
			</div> */}
		</div>
	);
};

export default ServiceHighlightsSection;
